import React from 'react';
import { IconProps } from '.';

const SvgTimeline = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='M18.75 15.25a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5h8.5ZM16.25 11.25a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5h8.5ZM13.75 7.25a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5h8.5Z'
      />
      <path
        fill={color}
        fillRule='evenodd'
        d='M21.204 3.01A2 2 0 0 1 23 5v14l-.01.204a2 2 0 0 1-1.786 1.785L21 21H3l-.204-.01a2 2 0 0 1-1.785-1.786L1 19V5a2 2 0 0 1 1.796-1.99L3 3h18l.204.01ZM3 4.5a.5.5 0 0 0-.5.5v14a.5.5 0 0 0 .5.5h18a.5.5 0 0 0 .5-.5V5a.5.5 0 0 0-.5-.5H3Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgTimeline;
